import { v4 as uuidv4 } from 'uuid';

const STORAGE_KEY = 'externalCustomerReference';
let inMemoryFallback: string | null = null;

export const getExternalCustomerReference = (): string => {
    try {
        const existing = sessionStorage.getItem(STORAGE_KEY);
        if (existing) return existing;

        const created = uuidv4();
        sessionStorage.setItem(STORAGE_KEY, created);
        return created;
    } catch {
        // private mode / storage disabled
        if (inMemoryFallback === null) inMemoryFallback = uuidv4();
        return inMemoryFallback;
    }
};
